// extracted by mini-css-extract-plugin
module.exports = {"hidden":"LBkv-","videoContainer":"F1LLt","small":"_9jhlf","local":"_2FSMg","sharing":"_1aJ51"};